<template>
  <div id="app">
    <div class="text_box">
      <div class="text">网站维护中，敬请期待...</div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100vh;
  .text_box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      font-size: 42px;
      color: #333;
    }
  }
}
@media (max-width: 767px) {
  #app {
    .text_box {
      .text {
        font-size: 22px;
      }
    }
  }
}

</style>
